import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { Box, Flex } from 'rebass';

import { Typography } from '@oca/ui';
import dayjs from 'dayjs';
import { Card } from '../molecules';

export function MeetingsSection({ date, list, linkTo, onItemClick }) {
  return (
    <Box marginBottom={3} marginTop={3}>
      <Typography variant="h2" marginBottom={3}>
        {date ? dayjs(new Date(date)).format('MMMM DD, dddd') : '---'}
      </Typography>
      <Flex flexWrap="wrap">
        {list.map((item, idx) => {
          const lastItem = idx === list.length - 1;

          return (
            <Box
              key={item.id}
              mr={lastItem ? 0 : 3}
              marginBottom={2}
              width="100%"
            >
              <Link
                to={`${linkTo}/${item.id}`}
                style={{ textDecoration: 'none ' }}
              >
                <Card
                  onClick={
                    onItemClick ? event => onItemClick(item, event) : undefined
                  }
                  title={item.title}
                  startTime={item.startTime}
                  endTime={item.endTime}
                  location={item.location}
                  project={item.project ? item.project.name : '---'}
                  status={item.status}
                  assignees={item.invitedEmployees}
                  date={date}
                />
              </Link>
            </Box>
          );
        })}
      </Flex>
    </Box>
  );
}

MeetingsSection.propTypes = {
  // eslint-disable-next-line react/require-default-props
  date: PropTypes.string,
  list: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number,
    }),
  ),
  // eslint-disable-next-line react/require-default-props
  onItemClick: PropTypes.func,
  linkTo: PropTypes.string.isRequired,
};

MeetingsSection.defaultProps = {
  list: [],
};
